import React from 'react'
import { Separator } from '@fs/zion-ui'
import GroupData from '../imageBrowse/groupData/GroupData'
import MetadataAuditInfoSheetFooter from './MetadataAuditInfoSheetFooter'
import MetadataAuditHeader from './MetadataAuditHeader'

export default function MetadataAuditInfoSheet() {
  return (
    <>
      <MetadataAuditHeader />
      <GroupData hideHeader />
      <Separator size="xxl" />
      <MetadataAuditInfoSheetFooter />
    </>
  )
}
